@if (isBackShown) {
  <button
    mat-button
    class="back-button position-absolute"
    [disabled]="isSubmittingPayment"
    (click)="backClicked()"
    aria-label="Back"
  >
    <i class="ri-arrow-left-s-line"></i>
  </button>
}
<div class="payment-container d-flex flex-column align-items-center pb-20">
  @if (isOneTime) {
    @if (data.payment!.title) {
      <h4 class="text-center">{{ data.payment!.title }}</h4>
    }
  } @else {
    <h4 class="text-center">
      <span class="main-color" i18n="@@paymentRetentionPercent">92% of users</span>
      <span i18n="@@paymentRetentionSuffix"> stay with us after initial 30-day subscription</span>
    </h4>
  }

  <div class="d-flex w-100 justify-content-space-between mt-10">
    <div class="fw-semibold" i18n="@@total">Total:</div>
    <div>
      <span class="full-price">{{ compareAtPriceLabel }}</span
      ><span class="ms-5">{{ priceLabel }}</span>
    </div>
  </div>

  @if (isLoading) {
    <div class="w-100 d-flex p-30 mt-20 justify-content-center">
      <mat-spinner mode="indeterminate" diameter="50"></mat-spinner>
    </div>
  }

  @if (hasLoadFailed) {
    <div class="red-color fs-13 text-center mt-20" i18n="@@paymentFormLoadError">
      The payment form couldn't be loaded. Please check your connection and try again.
    </div>
    <button
      mat-flat-button
      class="fw-semibold tagus w-100 mt-16"
      (click)="retryLoad()"
      i18n="@@paymentFormRetry"
    >
      Try again
    </button>
  }

  <form
    #stripeForm
    class="w-100 d-flex flex-column mt-20"
    [class.hidden]="isLoading || hasLoadFailed"
  >
    @if (!data.email && !isOneTime) {
      <div #stripeEmail class="mb-20">
        <!-- <span *ngIf="email" class="muted-color">Email: {{email}}</span> -->
      </div>
    }
    <div #expressCheckout [class.hidden]="!isExpressMethodsAvailable"></div>
    @if (isExpressMethodsAvailable) {
      <div class="separator w-100 d-flex align-items-center">
        <div class="left-line"></div>
        <div class="text-center fs-14 mt-10 mb-10 label" i18n="@@or">Or</div>
        <div class="right-line"></div>
      </div>
    }
    <div #stripeElement></div>
    <button
      mat-flat-button
      class="fw-semibold tagus w-100 mt-24"
      [disabled]="isLoading || isSubmittingPayment || !isPaymentElementReady"
      (click)="onPurchaseClicked($event)"
    >
      {{ data.buttonTitle }}
    </button>
    @if (data.isDisclaimerShown && data.product) {
      <div class="text-hint mt-20" i18n="@@paymentDisclaimer">
        We’ve automatically applied discount to your first subscription price. You will be charged
        {{ data.product.priceLabel }}. Please note that your subscription will be automatically
        renewed at full price of {{ data.product.fullPriceLabel }} at the end of chosen subscription
        term. Terms and Conditions apply. If you want to manage your subscription, you may do so via
        your personal account.
      </div>
    }
  </form>
  <div class="muted-color mt-20 fs-12">
    <a target="_blank" href="https://www.getpeech.com/terms" i18n="@@termsConditions"
      >Terms & Conditions</a
    >
  </div>
</div>
